import { useState } from 'react';
import { DeleteForbiddenModal } from '../../../../components/DeleteForbiddenModal/DeleteForbiddenModal';
import { Page } from '../../../../components/Page/Page';
import {
  SubjectContainerUsedIn,
  SubjectContainerUsedInDataType,
} from '../../../../components/SubjectContainer/components/SubjectContainerUsedIn';
import { loadSubjectContainerUsedIn } from '../../../../components/SubjectContainer/graphql/loadSubjectContainerUsedIn';
import { SubjectContainerModal } from '../../../../components/SubjectContainer/modals/SubjectContainerModal';
import { SubjectContainersTable } from '../../../../components/SubjectContainer/Tables/SubjectContainersTable';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { useDeleteSubjectContainerMutation } from '../../../../types/planung-graphql-client-defs';

export const DeputateSubjectContainersSubpage = () => {
  const context = useMemorizedCacheTag('SUBJECT_CONTAINER');
  const permissions = usePermissionChecker();

  const [, deleteSubjectContainer] = useDeleteSubjectContainerMutation();

  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [deleteForbidden, setDeleteForbidden] = useState<SubjectContainerUsedInDataType | null>(null);

  const [subjectContainerUuid, setSubjectContainerUuid] = useState<string | null>(null);

  function handleClose() {
    setSubjectContainerUuid(null);
    setModalOpen(false);
  }

  function handleAdd() {
    setSubjectContainerUuid(null);
    setModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setSubjectContainerUuid(uuid);
    setModalOpen(true);
  }

  async function handleDelete(uuids: string[]) {
    setTableLoading(true);

    const usedIn = await loadSubjectContainerUsedIn(uuids);

    if (usedIn) {
      setTableLoading(false);
      setDeleteForbidden(usedIn);
      return;
    }
    await deleteSubjectContainer({ uuids }, context);
    setTableLoading(false);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <SubjectContainersTable loading={tableLoading} onAdd={handleAdd} onEdit={handleEdit} onDelete={handleDelete} />
      <SubjectContainerModal isOpen={modalOpen} onClose={handleClose} subjectContainerUuid={subjectContainerUuid} />
      <DeleteForbiddenModal open={!!deleteForbidden} onClose={() => setDeleteForbidden(null)}>
        {deleteForbidden && <SubjectContainerUsedIn data={deleteForbidden} />}
      </DeleteForbiddenModal>
    </Page>
  );
};
